import { Flex } from "antd";
import { useDataQuery } from "hooks/useData";
import { useIsMobile } from "hooks/useIsMobile";
import React, { useCallback, useMemo } from "react";
import BubbleButton from "ui/BubbleButton";

type OwnProps = {
  activeSphere?: number | null;
  onChooseSphere?: (id: number | null, slug?: string | null) => void;
};

const TopBar: React.FC<OwnProps> = ({ activeSphere, onChooseSphere }) => {
  const { isMobile } = useIsMobile();

  const spheres = useDataQuery(`spheres`);

  const shpereList = useMemo(() => {
    if (!spheres) return [];

    return [
      ...spheres,
      {
        id: 0,
        slug: "all",
        title: "Все сферы",
      },
    ];
  }, [spheres]);

  const handleSphereClick = useCallback(
    (sphere: { id: number; slug?: string }) => {
      onChooseSphere?.(sphere.id, sphere.slug);
    },
    [onChooseSphere],
  );

  if (!spheres) return null;

  const buttonList = (
    <div className="top-bar-container">
      <div className={isMobile ? "top-bar-mobile" : "top-bar"}>
        {shpereList.map((sphere, index, array) => {
          return (
            <BubbleButton
              borderColor={"#666"}
              text={sphere.title}
              key={sphere.id}
              disabled={false}
              backgroundColor={
                activeSphere === sphere.id ? "#FCD757" : "#FFF2CB"
              }
              onClick={() => handleSphereClick(sphere)}
              round={
                index === 0
                  ? "left"
                  : index === array.length - 1
                    ? "right"
                    : "none"
              }
            />
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={isMobile ? "main-menu-mobile" : "main-menu"}>
      <Flex
        align="start"
        gap="18px"
        justify={"space-between"}
        style={isMobile ? { width: "100%" } : {}}
      >
        {buttonList}
      </Flex>
    </div>
  );
};

export default TopBar;
